import styled from '@emotion/styled'
import { AD_UNIT_MEDIATYPES } from '@pubstack/common/src/adFormat'
import React, { FunctionComponent, ReactNode } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { normalizeAsTrackingLabel, TrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { SelectorOptionCard } from '~/components/SelectorOptionCard'
import { AdFormatDisplay } from '~/modules/adm/inventory/adunits/AdFormatDisplay'
import { WithClassName } from '~/types/utils'
import { AdFormatCardHelpFlyout } from './AdFormatCardHelpFlyout'

const Mediatypes = styled.div`
  ${Fonts.P3};
`

export const AdFormatMediatype = styled.span<{ isPresent: boolean }>`
  color: ${({ isPresent }) => (isPresent ? Colors.Jet : Colors.Silver)};
`

export type AdFormatCardProps = WithClassName & {
  adFormat: AdFormatDisplay
  isSelected: boolean
  onClick: React.MouseEventHandler<HTMLDivElement>
  trackingLabel: TrackingLabel
}

const BaseAdFormatCard: FunctionComponent<AdFormatCardProps> = ({ className, adFormat, isSelected, onClick, trackingLabel }) => {
  const flyout = useGlobalFlyout()
  return (
    <SelectorOptionCard
      className={className}
      iconName={adFormat.iconName}
      title={adFormat.name}
      subtitle={
        <Mediatypes>
          {adFormat.mediatypes.includes('Instream') ? (
            <AdFormatMediatype key="Instream" isPresent={true}>
              Instream
            </AdFormatMediatype>
          ) : (
            AD_UNIT_MEDIATYPES.filter((mediaType) => mediaType !== 'Instream')
              .map<ReactNode>((mediatype) => (
                <AdFormatMediatype key={mediatype} isPresent={adFormat.mediatypes.includes(mediatype)}>
                  {mediatype}
                </AdFormatMediatype>
              ))
              .reduce((prev, curr) => [prev, ' | ', curr])
          )}
        </Mediatypes>
      }
      isSelected={isSelected}
      onClick={onClick}
      trackingLabel={trackingLabel}
      openHelpClick={() => flyout.open(AdFormatCardHelpFlyout, { color: Colors.Turquoise, closeTrackingLabel: `adm-ad-units-${normalizeAsTrackingLabel(adFormat.id)}-help` }, { adFormat })}
    />
  )
}

export const AdFormatCard = styled(BaseAdFormatCard)``
